import React, { useEffect, useRef } from 'react';
import { X } from 'lucide-react';

const CatalogModal = ({ isOpen, onClose, productCategory }) => {
  const formRef = useRef(null);

  useEffect(() => {
    if (isOpen && formRef.current) {
      // Clear previous form content (DOM removal, not innerHTML, to avoid any HTML injection)
      while (formRef.current.firstChild) {
        formRef.current.removeChild(formRef.current.firstChild);
      }

      // Create the Pipedrive web form container
      const container = document.createElement('div');
      container.className = 'pipedriveWebForms';
      container.setAttribute(
        'data-pd-webforms',
        'https://webforms.pipedrive.com/f/1AjPKJlhU9S3Mfq6ERZEdxnkjyIXaMm1uUKuImaGJmojli53RgFRqzCZjzXMwRRNF'
      );
      formRef.current.appendChild(container);

      // Load the Pipedrive loader script
      const script = document.createElement('script');
      script.src = 'https://webforms.pipedrive.com/f/loader';
      script.async = true;
      formRef.current.appendChild(script);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center" data-testid="catalog-modal">
      <div
        className="absolute inset-0 bg-black/50 backdrop-blur-sm"
        onClick={onClose}
        data-testid="catalog-modal-backdrop"
      />

      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-lg mx-4 p-8 md:p-10 max-h-[90vh] overflow-y-auto">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-stone-400 hover:text-stone-600 transition-colors z-10"
          data-testid="catalog-modal-close"
          aria-label="Close dialog"
        >
          <X size={24} />
        </button>

        <h3 className="text-blue-900 text-xl font-semibold text-center mb-6">
          Access {productCategory} Catalog
        </h3>

        <div ref={formRef} data-testid="catalog-pipedrive-form" />
      </div>
    </div>
  );
};

export default CatalogModal;
